import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import Feature from "ol/Feature";
import { GlobalSelectionControlService } from "../map/services/global-selection-control.service";
import {RangeRingToolService} from "../map/services/range-ring-tool.service";
import {CoordinatePointModel} from "../models/coordinate-point";
import {DisplayCalculationInfo} from "../models/DisplayCalculationInfo";
import {CoordinatePointTypes, FeatureType, getCoordinatePointTypesKeyByValue} from "../models/EnumTypes";
import {NavaidModel} from "../models/navaid";
import {PerformanceAnalysisDTO} from "../models/performanceAnalysisDTO";
import {PerformanceReportDTO} from "../models/performanceReportDTO";
import {ProcedureModel} from "../models/procedure";
import {Tab} from "../models/Tab";
import {TabDTO} from "../models/TabDTO";
import {DynamicTable} from "../popup/dynamic-table/dynamic-table.component";
import {AirSpaceBoundaryFilterService} from "./air-space-bondary-filter.service";
import {AirspaceBoundariesControlService} from "./airspace-boundaries-control.service";
import {AltitudeFilterService} from "./altitude-filter.service";
import {AzimuthToolService} from "../map/services/azimuth-tool.service";
import {BarometricToolService} from "./barometric-tool.service";
import {CalculationsService} from "./calculations.service";
import {CoordinatePointsFilterService} from "./coordinate-points-filter.service";
import {CoordinatePointsService} from "./coordinate-points.service";
import {CoverageQuantitativeAssessmentService} from "./coverage-quantitative-assessment.service";
import {EndpointsService} from "./endpoints.service";
import {FomCheckService} from "./fom-check.service";
import {HorizonToolService} from "./horizon-tool.service";
import {MapSearchService} from "./map-search.service";
import {ModalControlService} from "./modal-control.service";
import {MultipathToolService} from "./multipath-tool.service";
import {NavaidFromMapService} from "./navaid-from-map.service";
import {NavaidsCoChannelsService} from "./navaids-co-channels.service";
import {NavaidsFilterService} from "./navaids-filter.service";
import {NavaidsService} from "./navaids.service";
import {PerformanceReportService} from "./performance-report-service";
import {PointsService} from "./points.service";
import {ProcedureAssessmentsService} from "./procedure-assessments.service";
import {ProcedureControlService} from "./procedure-control.service";
import {ProceduresFilterService} from "./procedures-filter.service";
import {ProjectService} from "./project.service";
import {TerrainGridService} from "./terrain-grid.service";
import {ToolsControlService} from "./tools-control.service";
import {TrajectoryFilterService} from "./trajectory-filter.service";
import {UtilsService} from "./utils.service";
import {AddProjectControlService} from "./add-project-control.service";
import {SaamTrafficService} from "./saamtrafficservice";
import {CrossSectionService} from './cross-section.service';
import { Subscription, interval, of, takeWhile } from "rxjs";
import {AnalysisToolService} from "./analysis-tool.service";
import { Calculation, CalculationModel,CalculationResulModel } from "../models/calculations";
import { cloneDeep, head } from "lodash";
import { FormGroup } from "@angular/forms";
import { MapService } from "./map.service";
import {ProgressService} from "./progress.service";
import { Component, ElementRef, ViewChild } from '@angular/core';
import { CalculationValidation } from "./calculation-validation.service";
import { Geometry } from "ol/geom";
import { SelfTrainingToolService } from "./self-training-tool.service";
import { SelectAntennaPatternService } from "./select-antenna-pattern.service";

//#region GRIT
import {GritInterferenceTestDeviceService} from "./grit/grit.interference-test-device.service";
import {GritInterferenceTestService} from "./grit/grit.interference-test.service";
import {ReceiverModel} from "../models/grit/grit.receiver-model";
import {DeviceModel, InterferenceTestDeviceModel} from "../models/grit/grit.device-model";
import {InterferenceTestModel} from "../models/grit/grit.interference-test-model";
import {RadarModel} from "../models/grit/grit.radar-model";
import {GritRadarService} from "./grit/grit.radar.service";
import {GritFeatureFilterService} from "./grit/grit.feature-filter.service";
import {GritDynamicTableMode} from "../models/grit/grit.enums";
import {GritDeviceService} from "./grit/grit.device.service";
import { GritReceiverService } from "./grit/grit.receiver.service";
//endregion






@Injectable({
  providedIn: 'root'
})
export class TabsService{
  public footerActive = false;
  public tabs: Tab[] = [];
  public switchTabBlocked: boolean = false;
  //public visibleTabs : Tab[] = []
  public currentTab: Tab;
  public minimizeScreenMode = false;
  public fullScreenMode = false;
  public currentIndex: number;
  private appliedFooterMapShiftPx = 0;

  static CREATE_NAVAID_TYPE = "Create Navaid"
  static EDIT_NAVAID_TYPE= "Edit Navaid"
  static CREATE_PROCEDURE= "Create Procedure"
  static EDIT_PROCEDURE= "Edit Procedure"
  static CREATE_COORDINATE_POINTS = "Create Coordinate Points"
  static EDIT_COORDINATE_POINTS = "Edit Coordinate Points"
  static CREATE_AIRSPACE_BOUNDARIES = "Create Air Space Boundary from Map"
  static EDIT_AIRSPACE_BOUNDARIES = "Edit AirSpace Boundary"
  static PERFORMANCE_ANALYSIS = "Performance Analysis";
  static PERFORMANCE_REPORT = "Performance Report";
  static VERTICAL_PROFILE = "Vertical Profile";
  static NAVAID_CO_CHANNEL_CHECK = "NavAids Co-Channels"

  static SEPARATOR = "////" ;
  static DATA_PERFORMANCE_ANALYSIS_SEPARATOR = "&&&&";


  //tools
  static ALTITUDE_FILTER = "Altitude Filter";
  static BAROMETRIC_CALCULATION_TOOL = "Barometric Calculation Tool";
  static TERRAIN_GRID= "Terrain Grid";
  static HORIZON_TOOL="Horizon Tool";
  static MAP_SEARCH="Map Search";
  static MULTIPATH_TOOL="Multipath Tool";
  static NAVAID_FILTER = "Navaid Filter";
  static CP_FILTER = "Coordinate Point Filter";
  static PROCEDURE_FILTER = "Procedure Filter";
  static TRAJECTORY_FILTER = "Trajectory Filter";
  static AIR_SPACE_BOUNDARY_FILTER = "Airspace Boundary Filter";
  static CROSS_SECTION = "Cross Section";
  static ANALYSIS_TOOL = "Analysis Tool";
  static CALCULATION_CONFIGURATION = "Calculation Configuration";
  static readonly SELF_TRAINING_TOOL = "Self Training Tool";


  static CQA_RESULT = "Coverage Quantitative Assessment";
  static CREATE_CP_WITH_AZIMUTE_AND_DISTANCE = "Create Coordinate Point with Azimute and Distance";
  static CREATE_CP_FROM_NAVAID = "Create Coordinate Point from Navaid"
  static CREATE_PROCEDURE_FROM_SELECTED_ZONE = "Create Procedure From Selected Zone";
  static PROCEDURE_FROM_ASSOCIATED_NAVAIDS ="Procedure From Associated Navaids";
  static CREATE_NAVAID_FROM_MAP ="Create Navaid From Map";
  static CREATE_AIRSPACE_BOUNDARIES_FROM_VERTICES = "Create AirSpace Boundaries from Selected Vertices.";
  static PROCEDURE_ASSESSMENT = "Procedure Assessment";
  static CREATE_PROCEDURE_FROM_CSV ="Create Procedure from CSV";
  static FOM_CHECK = "Fom Check";
  static RANGE_RING = "Range Ring";
  static AZIMUTH_TOOL = "Azimuth Tool";
  static PROJECT_DETAILS = "Project Details";
  static SAAM_Filter ="SAAM Filter";
  static CREATE_PROCEDURE_FROM_ROUTE = "Create Procedure From Route";
  static readonly CREATE_PROCEDURE_CP_FILE = "Create Procedure From File";

  //#region GRIT Import
  static readonly FEATURE_FILTER = "Filter";

  static readonly MANAGE_DEVICES = "Manage RFI-Transmitters"
  static readonly MANAGE_RECEIVERS = "Manage Receivers"

  static readonly CREATE_DEVICE = "Create RFI-Transmitter";
  static readonly EDIT_DEVICE = "Edit RFI-Transmitter";

  static readonly INTERFERENCE_TEST = "Interference Test";
  static readonly INTERFERENCE_TEST_FILTER = "Interference Test Filter";

  static readonly CREATE_RADAR = "Create Radar";
  static readonly EDIT_RADAR = "Edit Radar";
  //#endregion

  //@View('navaidPrimaryForm', { static: false }) navaidFormElement: ElementRef;

  constructor(public navaidsControlService : NavaidsService,
    public procedureController: ProcedureControlService,
    public toolsService: ToolsControlService,
    public pointsService: PointsService,
    public coordinatePointsController : CoordinatePointsService,
    public airspaceBoundariesService : AirspaceBoundariesControlService,
    private popupService : BsModalService,
    private utilsService : UtilsService,
    public modalService : ModalControlService,
    public http : HttpClient,
    public endpointService: EndpointsService,
    private performanceReportService: PerformanceReportService,
    private calculationService: CalculationsService,
    private altitudeFilterService :  AltitudeFilterService,
    private barometricToolController: BarometricToolService,
    public terrainGridController: TerrainGridService,
    public horizonToolController: HorizonToolService,
    public multipathToolController: MultipathToolService,
    public mapSearchController: MapSearchService,
    public cqaController : CoverageQuantitativeAssessmentService,
    private projectService : ProjectService,
    private navaidFromMapService : NavaidFromMapService,
    public navaidsFilterService : NavaidsFilterService,
    public proceduresFilterService: ProceduresFilterService,
    public coordinatePointsFilterService: CoordinatePointsFilterService,
    public airspaceBoundaryFilterService: AirSpaceBoundaryFilterService,
    public trajectoryFilterService: TrajectoryFilterService,
    public procedureAssessmentController: ProcedureAssessmentsService,
    public navaidsCoChannelCheckService: NavaidsCoChannelsService,
    public fomCheckservice : FomCheckService,
    public rangeRingService : RangeRingToolService,
    public azimuthToolService : AzimuthToolService,
    private projectDetailService : AddProjectControlService,
    public saamTrafficService: SaamTrafficService,
    public crossSectionService: CrossSectionService,
    public analysisToolService: AnalysisToolService,
    private progressService: ProgressService,
    private calculationValidationService: CalculationValidation,
    private selfTrainingToolService: SelfTrainingToolService,

    //#region GRIT
    public deviceService: GritDeviceService,
    public receiverService: GritReceiverService,
    public interferenceTestDeviceService: GritInterferenceTestDeviceService,
    public interferenceTestService: GritInterferenceTestService,
    public featureFilterService: GritFeatureFilterService,
    public radarService: GritRadarService,
    //#endregion
    public antennaPatternService: SelectAntennaPatternService,
    private mapService: MapService
  ){
    this.progressService.openNewPerformanceAnalysisTabFunction = (performanceAnalysis, data, id) => this.openNewPerformanceAnalysisTab(performanceAnalysis, data, id);
    this.progressService.openNewVerticalProfileTabFunction =  (performanceAnalysis, data) => this.openNewVerticalProfileTab(performanceAnalysis, data);
    this.progressService.openNewPerformanceReportTabFunction = (performanceAnalysis, data) =>
                                                                                      this.openNewPerformanceReportTab(performanceAnalysis, data);
    this.progressService.openNewCoveraveQuantitativeAssessmentTab = (data) => this.openNewCoveraveQuantitativeAssessmentTab(data);

    this.pointsService.tabsService = this;

    const checkAuthSubscription: Subscription = interval(100) // ms
      .pipe(takeWhile(() => !this.endpointService.httpOptions, true))
      .subscribe(() => {
        if (this.endpointService.httpOptions) {
          checkAuthSubscription.unsubscribe();
          this.initializeTabsService();
        }
      });
  }

  public initializeTabsService(){
    this.http.get(
      this.endpointService.apiURLTabsGet,
      {
        ...this.endpointService.httpOptions,
      }
    ).subscribe((tabs:any) =>{
      if(tabs == null){
        this.http.post(
          this.endpointService.apiURLTabsCreate,
          null,
          {
            ...this.endpointService.httpOptions,
          }
        ).subscribe((tabs: any) =>{
          console.log();
        })
      }
      else{
        if(tabs.tabInfo == "" || tabs.tabInfo == "[]" ){
          return;
        }
        this.tabs = JSON.parse(tabs.tabInfo);

        let i = this.tabs.findIndex((tab) => tab.visible);
        if(i == -1){
          return;
        }
        //this.setCurrentTab(i)
        this.minimizeScreenMode = true;
        this.footerActive = true;
        this.navaidsControlService.openFooter();
      }
    }
    )
  }


  setCurrentTab(i){
    this.currentTab = this.tabs[i];
    this.currentIndex = i;
  }
  updateTabs(){
    let tabdto :TabDTO = this.createTabDTO(this.tabs);
    this.updateTabsHttpRequest(tabdto).subscribe((result) =>{});
  }
  openTabs(){
    this.toolsService.navigationOnTop = true;
    //this.footerActive = true;
    this.minimizeScreenMode = false;
    this.syncMapCenterAfterFooterLayout();
  }
  closeTabs(save?:boolean){
    //this.footerActive = false;
    this.toolsService.navigationOnTop = false;
    if(this.currentTab != null )
      this.hideTab(this.currentTab,true,save,true);
    this.currentTab = null;
    this.currentIndex = null;
    this.navaidsControlService.closeFooter();
    this.footerActive = false;
    this.syncMapCenterAfterFooterLayout();
  }
  createTabDTO(objectData:any){
    let tabdto :TabDTO = new TabDTO();
    tabdto.tabInfo = JSON.stringify(objectData);
    return tabdto;
  }
  showAdjacentVisibleTab(index:number,close:boolean,save?:boolean,toggle?:boolean){
    for(let i=index;i < this.tabs.length;i++){
      if(this.tabs[i].visible){
        this.showTab(i,close,save,toggle)
        return;
      }
    }
    for(let i=index-1; i >= 0; i--){
      if(this.tabs[i].visible){
        this.showTab(i,close,save,toggle);
        return;
      }
    }
  }
  restoreMap(i:number){
    this.saveCurrentTab();
    if(this.tabs[i].type == TabsService.EDIT_AIRSPACE_BOUNDARIES){
      this.airspaceBoundariesService.setEditAirSpace(JSON.parse(this.tabs[i].data));
      this.airspaceBoundariesService.restoreMap(true, true);
      this.airspaceBoundariesService.hideFooter()
      if(this.currentTab.type == TabsService.EDIT_AIRSPACE_BOUNDARIES || this.currentTab.type == TabsService.CREATE_AIRSPACE_BOUNDARIES){
        this.showTab(this.currentIndex);
      }
    }
    if(this.tabs[i].type == TabsService.CREATE_AIRSPACE_BOUNDARIES){
      const id : number = JSON.parse(this.tabs[i].header.split('#')[1]);
      this.airspaceBoundariesService.restoreMap(true, true,id);
    }
    if(this.tabs[i].type == TabsService.EDIT_PROCEDURE ){
      let procedure :any = JSON.parse(this.tabs[i].data);
      this.procedureController.setEditProcedure(procedure);
      this.procedureController.restoreMap(procedure);
      this.procedureController.hideFooter();
      if(this.currentTab.type == TabsService.EDIT_PROCEDURE || this.currentTab.type == TabsService.CREATE_PROCEDURE
        || this.currentTab.type == TabsService.CREATE_PROCEDURE_FROM_CSV || this.currentTab.type == TabsService.CREATE_PROCEDURE_FROM_ROUTE ){
        this.showTab(this.currentIndex);
      }

    }
    if(this.tabs[i].type == TabsService.CREATE_PROCEDURE || this.tabs[i].type == TabsService.CREATE_PROCEDURE_FROM_CSV
      || this.tabs[i].type == TabsService.CREATE_PROCEDURE_FROM_ROUTE || this.tabs[i].type == TabsService.CREATE_PROCEDURE_CP_FILE){
        const id : number = JSON.parse(this.tabs[i].header.split('#')[1]);
        this.procedureController.restoreMap(JSON.parse(this.tabs[i].data),id);
    }
    if(this.tabs[i].type == TabsService.PROCEDURE_ASSESSMENT){
      this.procedureAssessmentController.restoreMapAndClearVariables(JSON.parse(this.tabs[i].data));
    }
    if(this.tabs[i].type == TabsService.NAVAID_CO_CHANNEL_CHECK){
      this.navaidsCoChannelCheckService.cancelWindow();
    }
    if(this.tabs[i].type == TabsService.MULTIPATH_TOOL){
      this.multipathToolController.closeFooter();
    }
    if(this.tabs[i].type == TabsService.RANGE_RING){
      this.rangeRingService.clearLayer();
    }
    if(this.tabs[i].type == TabsService.AZIMUTH_TOOL){
      this.azimuthToolService.clearLayer();
    }
    if(this.tabs[i].type == TabsService.TERRAIN_GRID){
      this.terrainGridController.cleanMap();
    }
    if(this.tabs[i].type == TabsService.SELF_TRAINING_TOOL){
      this.selfTrainingToolService.closeWindow();
    }

  }
  resetForm(i:number){
    if(this.tabs[i].type == TabsService.CREATE_NAVAID_TYPE
      || this.tabs[i].type == TabsService.EDIT_NAVAID_TYPE
      || this.tabs[i].type == TabsService.CREATE_NAVAID_FROM_MAP){
      (<HTMLFormElement>document.getElementById("navaidPrimaryForm")).reset();
      return;
    }
    if(this.tabs[i].type == TabsService.CREATE_PROCEDURE
      || this.tabs[i].type == TabsService.EDIT_PROCEDURE
      || this.tabs[i].type == TabsService.CREATE_PROCEDURE_FROM_ROUTE
      || this.tabs[i].type == TabsService.CREATE_PROCEDURE_FROM_SELECTED_ZONE
      || this.tabs[i].type == TabsService.PROCEDURE_FROM_ASSOCIATED_NAVAIDS
      || this.tabs[i].type == TabsService.CREATE_PROCEDURE_FROM_CSV){
      (<HTMLFormElement>document.getElementById("procedurePrimaryForm")).reset();
      return;
    }
    if(this.tabs[i].type == TabsService.CREATE_COORDINATE_POINTS
      || this.tabs[i].type == TabsService.EDIT_COORDINATE_POINTS
      || this.tabs[i].type == TabsService.CREATE_CP_FROM_NAVAID
      || this.tabs[i].type == TabsService.CREATE_CP_WITH_AZIMUTE_AND_DISTANCE){
      (<HTMLFormElement>document.getElementById("coordindatePointsForm")).reset();
      return;
    }
    if(this.tabs[i].type == TabsService.CREATE_AIRSPACE_BOUNDARIES
      || this.tabs[i].type == TabsService.EDIT_AIRSPACE_BOUNDARIES
      ||this.tabs[i].type == TabsService.CREATE_AIRSPACE_BOUNDARIES_FROM_VERTICES){
        (<HTMLFormElement>document.getElementById("formAirSpaceBoundary")).reset();
        return;
    }
  }
  async closeTab(i?: any,forceClose?:boolean,close: boolean=true,save?:boolean){
    if(typeof i == 'undefined'){
      i = this.currentIndex;
    }
    if(typeof forceClose == 'undefined'){
      forceClose = false;
    }

    //#region GRIT Close Tab
    if(this.tabs[i].type == TabsService.INTERFERENCE_TEST){
      if (this.interferenceTestService.detailsTab.selected.id == this.interferenceTestService.projectInterferenceTest?.id){
        await this.interferenceTestService.resetProjetInterferenceTest(); //Reset value when tab is closed
      }

      else if(this.tabs[i].data == String(this.interferenceTestService.focusPublicInterferenceTest?.id)){
        this.pointsService.clearOtherInterferenceTestFromMap(); //Clean all public it
        this.pointsService.fetchAndAddInterferenceTest(); //Add public it
        this.interferenceTestService.focusPublicInterferenceTest = null;
      }
    }
    //endregion

    if(this.tabs[i].type == TabsService.PERFORMANCE_ANALYSIS && !forceClose){
      this.tabs[i].visible = false;
    }
    else{
      if(i != this.currentIndex){
        this.restoreMap(i)
      }
      this.tabs.splice(i,1);
    }
    let tabdto :TabDTO = this.createTabDTO(this.tabs);
    this.updateTabsHttpRequest(tabdto).subscribe((result) => {
        if(this.tabs.filter((tab) => tab.visible).length == 0){
          this.closeTabs(save);
          return;
        }
        if(i == this.currentIndex){
          this.showAdjacentVisibleTab(i,close,save,false);
          return;
        }
        if(this.currentIndex > i){
          this.currentIndex--;
        }
     }
    )
  }

  updateTabsHttpRequest(tabdto: TabDTO){
    return this.http.post(
      this.endpointService.apiURLTabsUpdate,
      tabdto,
      {
        ...this.endpointService.httpOptions

      }
    )
  }

  minimizeWindow():void {
    this.toolsService.navigationOnTop = false;
    this.minimizeScreenMode = true;
    this.fullScreenMode = false;
    this.saveCurrentTab();
    this.syncMapCenterAfterFooterLayout();
  }

  fullScreenWindow():void {
    this.toolsService.navigationOnTop = true;
    this.fullScreenMode = !this.fullScreenMode;
    this.minimizeScreenMode = false;
    //this.saveCurrentTab();
  }

  private syncMapCenterAfterFooterLayout(): void {
    window.setTimeout(() => this.syncMapCenterWithFooterState(), 0);
  }

  private syncMapCenterWithFooterState(): void {
    const shouldApplyShift = this.footerActive && !this.minimizeScreenMode && !this.fullScreenMode;
    const targetShiftPx = shouldApplyShift ? this.getTargetFooterMapShiftPx() : 0;
    const deltaShiftPx = targetShiftPx - this.appliedFooterMapShiftPx;

    if (deltaShiftPx === 0) {
      return;
    }

    this.mapService.shiftCenterByPixels(0, deltaShiftPx);
    this.appliedFooterMapShiftPx = targetShiftPx;
  }

  private getTargetFooterMapShiftPx(): number {
    const activeFooter = document.querySelector('app-footer .bottom-menu.active:not(.minimized)') as HTMLElement;
    if (!activeFooter) {
      return 0;
    }

    const footerHeight = activeFooter.getBoundingClientRect().height;
    if (!footerHeight || footerHeight <= 0) {
      return 0;
    }

    return Math.round(footerHeight / 2);
  }

  saveCurrentTab(){

    if(this.currentTab == null)
      return;

    if(this.currentTab.type == TabsService.CREATE_NAVAID_TYPE || this.currentTab.type == TabsService.EDIT_NAVAID_TYPE){
      this.currentTab.data = JSON.stringify(this.navaidsControlService.getNavaidPayload(this.navaidsControlService.selectedNavaid));
      return;
    }
    if(this.currentTab.type == TabsService.CREATE_COORDINATE_POINTS || this.currentTab.type == TabsService.EDIT_COORDINATE_POINTS || this.currentTab.type == TabsService.CREATE_CP_FROM_NAVAID){
      this.currentTab.data = JSON.stringify(this.coordinatePointsController.getCoordinatePointPayload(this.coordinatePointsController.selectedCoordinatePoint));
      return;
    }
    if(this.currentTab.type == TabsService.CREATE_CP_WITH_AZIMUTE_AND_DISTANCE){
      this.currentTab.data = JSON.stringify(this.coordinatePointsController.getCoordinatePointPayload(this.coordinatePointsController.selectedCoordinatePoint)) +
        '////' + this.coordinatePointsController.azimuth + '$' +this.coordinatePointsController.distance;
    }
    if(this.currentTab.type == TabsService.CREATE_PROCEDURE_FROM_SELECTED_ZONE  || this.currentTab.type == TabsService.EDIT_PROCEDURE){
      this.currentTab.data = JSON.stringify(this.procedureController.selectCoordinatePointService.selectedProcedure);
      return;
    }
    if(this.currentTab.type == TabsService.CREATE_PROCEDURE
      || this.currentTab.type == TabsService.CREATE_PROCEDURE_FROM_CSV
      || this.currentTab.type == TabsService.CREATE_PROCEDURE_FROM_ROUTE
      || this.currentTab.type == TabsService.CREATE_PROCEDURE_CP_FILE) {
      this.currentTab.data = JSON.stringify(this.procedureController.selectCoordinatePointService.selectedProcedure);
      return;
    }
    if(this.currentTab.type == TabsService.PROCEDURE_ASSESSMENT){
      this.currentTab.data = JSON.stringify(this.procedureAssessmentController.procedureInterfaceToHTML)
      return;
    }
    if(this.currentTab.type == TabsService.EDIT_AIRSPACE_BOUNDARIES ){
      this.currentTab.data = JSON.stringify(this.airspaceBoundariesService.selectCoordinatePointService.selectedAirSpaceBoundary);
      return;
    }
    if(this.currentTab.type == TabsService.CREATE_AIRSPACE_BOUNDARIES){
      this.currentTab.data = JSON.stringify(this.airspaceBoundariesService.selectCoordinatePointService.selectedAirSpaceBoundary);
      return;
    }

    //#region GRIT Save Tab
    switch (this.currentTab.type) {
      // case TabsService.FEATURE_FILTER:
      //   this.featureFilterService.toggleFilter(true, JSON.parse(tab.data))
      //   break;

      case TabsService.CREATE_DEVICE:
      case TabsService.EDIT_DEVICE:
        this.currentTab.data = JSON.stringify(this.interferenceTestDeviceService.selectedDevice.toDTO());
        break;

      // case TabsService.INTERFERENCE_TEST:
      //   if(this.interferenceTestService.detailsTab.selected != null)
      //     this.currentTab.data = this.interferenceTestService.detailsTab.selected.guid;
      //   break;

      case TabsService.CREATE_RADAR:
      case TabsService.EDIT_RADAR:
        this.currentTab.data = JSON.stringify(this.radarService.detailsTab.selected);
        break;
    }
    //#endregion
  }

  openNewTab(tab:Tab){
    if(this.tabs.filter(tab => tab.visible).length < 10){
      let tabs: Tab[] = cloneDeep(this.tabs);
      tabs.push(tab);
      let tabdto :TabDTO = this.createTabDTO(tabs);
      this.switchTabBlocked = true;
      this.http.post(
        this.endpointService.apiURLTabsUpdate,
        tabdto,
      {
        ...this.endpointService.httpOptions
      }
      ).subscribe((result) => {
        this.footerActive = true;
        this.tabs.push(tab);
        this.openTabs();
        this.showTab(this.tabs.length -1,false, false, true);
        this.switchTabBlocked = false;
      })
    }else {
      this.modalService.showMesssageModal("Tabs Limit", "You have reached the maximum limit of open tabs (10).");
    }


  }
  performanceAnalysisTabMatchesWithID(tab:Tab,calcID:number){
    let analysisTypeArray :string[]= tab.data.split(TabsService.SEPARATOR);
      let id: number = parseInt(analysisTypeArray[1])
      return calcID == id;
  }
  openPerformanceAnalysisCalculation(calcID:number){
    this.footerActive = true;
    let index = this.tabs.findIndex((tab) => tab.type == TabsService.PERFORMANCE_ANALYSIS &&
                    this.performanceAnalysisTabMatchesWithID(tab,calcID))
    this.tabs[index].visible = true;
    this.showTab(index);
    this.updateTabs();
  }
  forceClosePerformanceAnalysisResultTab(calcID:number){
    let index = this.tabs.findIndex((tab) => tab.type == TabsService.PERFORMANCE_ANALYSIS &&
    this.performanceAnalysisTabMatchesWithID(tab,calcID));
    this.closeTab(index,true);
  }
  deleteCalculationTabs(calcIds:number[]){
    calcIds.forEach((calcID:number)=>{
      let index = this.tabs.findIndex((tab) => tab.type == TabsService.PERFORMANCE_ANALYSIS && this.performanceAnalysisTabMatchesWithID(tab,calcID));
      if(index != -1){
        this.tabs.splice(index,1);
      }
    });
    if(this.tabs.length == 0){
      this.closeTabs();
    }
    this.updateTabs();
  }

  hideTab(tab:Tab,close?:boolean,save?:boolean,toggle?:boolean){
    if(typeof close == 'undefined'){
      close = false;
    }
    if(tab.type == TabsService.CREATE_NAVAID_TYPE || tab.type == TabsService.EDIT_NAVAID_TYPE){
      if(toggle){
        this.saveCurrentTab();
        this.navaidsControlService.switchFooter();
      }
      else{
        this.navaidsControlService.closeFooter();
      }
    }
    else if(tab.type == TabsService.CREATE_PROCEDURE || tab.type == TabsService.CREATE_PROCEDURE_FROM_SELECTED_ZONE ||
        tab.type == TabsService.CREATE_PROCEDURE_FROM_CSV  || tab.type == TabsService.CREATE_PROCEDURE_FROM_ROUTE ||
        tab.type == TabsService.CREATE_PROCEDURE_CP_FILE){
      if(close){
        this.procedureController.closeFooter(save)
      }else {
        this.saveCurrentTab();
        this.procedureController.hideFooter();
      }

    }

    else if(tab.type == TabsService.EDIT_PROCEDURE){

      if(close){
        this.procedureController.closeFooter(save)
      }else {
        this.saveCurrentTab();
        this.procedureController.hideFooter();
      }

    }
    else if(tab.type == TabsService.CREATE_COORDINATE_POINTS || tab.type == TabsService.EDIT_COORDINATE_POINTS ||tab.type == TabsService.CREATE_CP_WITH_AZIMUTE_AND_DISTANCE || tab.type == TabsService.CREATE_CP_FROM_NAVAID){
      if(toggle){
        this.saveCurrentTab();
      }
      this.coordinatePointsController.closeFooter()

    }
    else if(tab.type == TabsService.CREATE_AIRSPACE_BOUNDARIES || tab.type == TabsService.CREATE_AIRSPACE_BOUNDARIES_FROM_VERTICES ){
      if(close){
        this.airspaceBoundariesService.closeFooter(save, !save);
      }else {
        this.saveCurrentTab();
        this.airspaceBoundariesService.hideFooter();
      }

    }else if(tab.type == TabsService.EDIT_AIRSPACE_BOUNDARIES) {
      if(close){
        this.airspaceBoundariesService.closeFooter(save, !save);
      }else {
        this.saveCurrentTab();
        this.airspaceBoundariesService.hideFooter();
      }
    }
    else if(tab.type == TabsService.PERFORMANCE_REPORT){
      this.performanceReportService.closeWindow()
    }
    else if(tab.type == TabsService.PERFORMANCE_ANALYSIS || tab.type == TabsService.VERTICAL_PROFILE){
      this.calculationService.closeFooter()
    }
    else if(tab.type == TabsService.ALTITUDE_FILTER){
      this.altitudeFilterService.active = false;
    }
    else if(tab.type == TabsService.BAROMETRIC_CALCULATION_TOOL){
      this.barometricToolController.active = false;
    }
    else if(tab.type == TabsService.HORIZON_TOOL){
      if(close){
        this.horizonToolController.cancelWindow();
      }else {
        this.horizonToolController.hideWindow();
      }
    }
    else if(tab.type == TabsService.ANALYSIS_TOOL){
      this.analysisToolService.closeWindow();
    }
    else if (tab.type == TabsService.CALCULATION_CONFIGURATION){
      this.calculationService.closeCalcInfoWindow();
    }
    else if( tab.type == TabsService.MAP_SEARCH){
      if(close)
        this.mapSearchController.cancelWindow();
      else
        this.mapSearchController.active = false;
    }
    else if(tab.type == TabsService.MULTIPATH_TOOL){
      if(close)
        this.multipathToolController.closeFooter();
      else{
        this.saveCurrentTab()
        this.multipathToolController.active = false;
      }
    }
    else if(tab.type == TabsService.TERRAIN_GRID){
      if(close)
        this.terrainGridController.closeFooter()
      else
        this.terrainGridController.switchFooter();
    }
    else if(tab.type ==  TabsService.CQA_RESULT){
      this.cqaController.closeWindow();
    }
    else if(tab.type == TabsService.CREATE_NAVAID_FROM_MAP){
      this.navaidFromMapService.closeWindow();
    }
    else if(tab.type == TabsService.PROCEDURE_FROM_ASSOCIATED_NAVAIDS){
      this.procedureController.closeProcedureNavaidAssociation();
    }
    else if(tab.type == TabsService.NAVAID_FILTER){
      this.navaidsFilterService.active = false;
    }
    else if(tab.type == TabsService.PROCEDURE_FILTER){
      this.proceduresFilterService.active = false;
    }
    else if(tab.type == TabsService.CP_FILTER){
      this.coordinatePointsFilterService.active = false;
    }
    else if(tab.type == TabsService.AIR_SPACE_BOUNDARY_FILTER){
      this.airspaceBoundaryFilterService.active = false;
    }
    else if(tab.type == TabsService.TRAJECTORY_FILTER){
      this.trajectoryFilterService.active = false;
    }
    else if(tab.type == TabsService.PROCEDURE_ASSESSMENT){
      if(close){
        this.procedureAssessmentController.clearProcedureAssessment();
      }else{
        this.saveCurrentTab()
        this.procedureAssessmentController.switchFooter();
      }
    }
    else if(tab.type == TabsService.NAVAID_CO_CHANNEL_CHECK){
      if(close){
        this.navaidsCoChannelCheckService.cancelWindow();
      } else {
        this.navaidsCoChannelCheckService.active = false;
      }
    }
    else if(tab.type == TabsService.FOM_CHECK){
      this.fomCheckservice.closeFooter();
    }
    else if(tab.type == TabsService.RANGE_RING){
      if(close)
        this.rangeRingService.closeFooter();
      else
        this.rangeRingService.hideFooter();
    }
    else if( tab.type == TabsService.AZIMUTH_TOOL){
      if(close)
        this.azimuthToolService.closeFooter();
      else
        this.azimuthToolService.hideFooter();
    }
    else if(tab.type == TabsService.PROJECT_DETAILS){
      this.projectDetailService.active = false;
    }
    else if(tab.type == TabsService.SAAM_Filter){
      this.saamTrafficService.active = false;
    } else if (tab.type == TabsService.CROSS_SECTION) {
      if(close){
        this.crossSectionService.cancelWindow();
      }else {
        this.crossSectionService.hideWindow();
      }

    }
    else if(tab.type ==  TabsService.SELF_TRAINING_TOOL){
      if (close){
        this.selfTrainingToolService.closeWindow();
      } else {
        this. selfTrainingToolService.hideWindow();
      }
    }

    //#region GRIT Hide
    switch (tab.type){
      case TabsService.FEATURE_FILTER:
        this.featureFilterService.toggleFilterTab(false)
        break;

      case TabsService.MANAGE_DEVICES:
        this.deviceService.toggleTab(false);
        break;
      case TabsService.MANAGE_RECEIVERS:
        this.receiverService.toggleTab(false);
        break;

      case TabsService.CREATE_DEVICE:
      case TabsService.EDIT_DEVICE:
        if (toggle) this.saveCurrentTab();
        this.interferenceTestDeviceService.hideTab();
        break;

      case TabsService.INTERFERENCE_TEST:
        if (toggle) this.saveCurrentTab();
        this.interferenceTestService.toggleDetails(false);
        break;

/*      case TabsService.INTERFERENCE_TEST_FILTER:
        this.interferenceTestService.toggleFilter(false)
        break;*/

      case TabsService.CREATE_RADAR:
      case TabsService.EDIT_RADAR:
        if (toggle) this.saveCurrentTab();
        this.radarService.toggleDetails(false)
        break;
    }
    //#endregion
  }

  showTab(i:number,close?:boolean,save?:boolean,toggle:boolean=true){

  this.navaidsControlService.closeFooter();
    if(typeof close == 'undefined'){
      close = false;
    }
    let tab: Tab = this.tabs[i];
    if(this.currentTab != null && tab != this.currentTab && tab.type != TabsService.PERFORMANCE_ANALYSIS){
      this.hideTab(this.currentTab,close,save,toggle);
    }
    if(tab.type == TabsService.CREATE_NAVAID_TYPE){
      if(tab.data == null)
        this.navaidsControlService.createNavaid();
      else
        this.navaidsControlService.createNavaid(JSON.parse(tab.data));
    }
    else if(tab.type == TabsService.EDIT_NAVAID_TYPE){
      let navaid: NavaidModel;
      if(typeof JSON.parse(tab.data) == 'number'){
        const feature : any = this.pointsService.getAllNavaidsFeaturesFromLayers().find(feat => feat.get("id") == JSON.parse(tab.data) && feat.get("featureType") == FeatureType.Navaid);
        navaid = this.pointsService.transformFeatureInNavaid(feature);
      }
      else{
        navaid = JSON.parse(tab.data);
      }
      this.navaidsControlService.defineEditInitState(navaid);
    }
    else if(tab.type == TabsService.CREATE_PROCEDURE || tab.type == TabsService.CREATE_PROCEDURE_CP_FILE
      || tab.type == TabsService.CREATE_PROCEDURE_FROM_ROUTE || tab.type == TabsService.CREATE_PROCEDURE_FROM_CSV){
      let id = JSON.parse(tab.header.split("#")[1])
      if(tab.type == TabsService.CREATE_PROCEDURE_FROM_CSV){
        this.procedureController.createProcedureFromCSV(JSON.parse(tab.data),id);
      }
      else{
          if(tab.data == null)
            this.procedureController.createProcedure(id);
          else{
            this.procedureController.createProcedure(id,JSON.parse(tab.data));
          }
      }
    }

    else if(tab.type == TabsService.CREATE_PROCEDURE_FROM_SELECTED_ZONE){
      if(tab.data.includes('$')){
        let ids:string[] = tab.data.split("$");
        let features:Feature[] = [];
        let allCPFeatures = this.pointsService.getAllCoordinatePointsFeaturesFromLayers();
        for(let id of ids){
          features.push(allCPFeatures.find((feature)=> feature.get('id') == parseInt(id)));
        }
        this.procedureController.setInitialStateOfCreateProcedureFromSelectedZone(features);
      }
      else{
        this.procedureController.createProcedure(JSON.parse(tab.data));
      }
    }
    else if (tab.type == TabsService.EDIT_PROCEDURE) {
      this.procedureController.openFooter();
      if (tab.data == "fromProcedureAssessment") {
        this.procedureController.setEditProcedureFromAssessment();
      } else{
        let procedure : any  = JSON.parse(tab.data);
        this.procedureController.setEditProcedure(procedure);

      }
    }
    else if(tab.type == TabsService.CREATE_AIRSPACE_BOUNDARIES){
      let id = JSON.parse(tab.header.split("#")[1])
      if(tab.data == null)
        this.airspaceBoundariesService.createAirspaceBoundary(id)
      else{
        this.airspaceBoundariesService.createAirspaceBoundary(id,JSON.parse(tab.data));
      }
    }
    else if(tab.type == TabsService.EDIT_AIRSPACE_BOUNDARIES){
      this.airspaceBoundariesService.openFooter();
      this.airspaceBoundariesService.setEditAirSpace(JSON.parse(tab.data));
    }
    else if(tab.type == TabsService.CREATE_COORDINATE_POINTS){
      if(tab.data == null)
        this.coordinatePointsController.createCP();
      else
        this.coordinatePointsController.createCP(JSON.parse(tab.data));
    }
    else  if(tab.type == TabsService.EDIT_COORDINATE_POINTS){
      let coordinatePoint: CoordinatePointModel = JSON.parse(tab.data);
      this.coordinatePointsController.setEditCPInitialState(coordinatePoint);
    }
    else if(tab.type == TabsService.PERFORMANCE_REPORT){
      this.performanceReportService.openWindow(JSON.parse(tab.data));
    }
    else if(tab.type == TabsService.PERFORMANCE_ANALYSIS){
      let analysisTypeArray :string[]= tab.data.split(TabsService.SEPARATOR);
      let performanceAnalysis = JSON.parse(analysisTypeArray[0]);
      let id = JSON.parse(analysisTypeArray[1]);
      this.calculationService.displayCalculation = DisplayCalculationInfo.getPerformanceAnalysisDisplay(performanceAnalysis);

      //TODO : remove setTimeout and use core library to detect *ngIf changes before executing showGeoJSONPerformanceAnalysis
      window.setTimeout(() =>  {
                            if(this.currentTab != null && tab != this.currentTab){
                              this.hideTab(this.currentTab,false,false,true);
                            }

                            this.http.get<CalculationModel>(
                              this.endpointService.getCalculation + '/'+ id,
                              this.endpointService.httpOptions
                            ).subscribe((calculation: CalculationModel) => {
                                  CalculationsService.decompressCalculationResult(calculation);
                                  this.calculationService.showGeoJSONPerformanceAnalysis(
                                      calculation.results.map((result:CalculationResulModel)=> result.result), true,false,false,performanceAnalysis.name, id, performanceAnalysis);
                                  this.minimizeScreenMode = false;
                                  this.toolsService.navigationOnTop =true;
                                  this.setCurrentTab(i);
                                  this.syncMapCenterAfterFooterLayout();
                                }
                              )
                              },10 )
      return;
      //this.calculationService.showGeoJSONPerformanceAnalysis(data, true,performanceAnalysis.name, -1, performanceAnalysis)
    }
    else if(tab.type == TabsService.VERTICAL_PROFILE ){
      let analysisTypeArray :string[]= tab.data.split(TabsService.SEPARATOR);
      let data = JSON.parse(analysisTypeArray[0]);
      let performanceAnalysis = JSON.parse(analysisTypeArray[1]);
      this.calculationService.showVerticalProfileChart(data, performanceAnalysis);
    }
    else if(tab.type == TabsService.ALTITUDE_FILTER){
      this.altitudeFilterService.openWindow();
    }
    else if(tab.type == TabsService.BAROMETRIC_CALCULATION_TOOL){
      this.barometricToolController.openWindow();
    }
    else if(tab.type == TabsService.HORIZON_TOOL){
      this.horizonToolController.openWindow();
    }
    else if(tab.type == TabsService.ANALYSIS_TOOL){
      const tabData: string[] = tab.data.split(TabsService.SEPARATOR);
      tabData.length > 1 ? this.analysisToolService.openWindow(Number.parseInt(tabData[0]), tabData[1]) :
                              this.analysisToolService.openWindow(Number.parseInt(tab.data));

    }
    else if (tab.type == TabsService.CALCULATION_CONFIGURATION){
      const tabData: string[] = tab.data.split(TabsService.SEPARATOR);
      this.calculationService.openCalcInfoWindow(Number.parseInt(tabData[0]), tabData[1]);
    }
    else if(tab.type == TabsService.MAP_SEARCH){
      this.mapSearchController.openWindow();
    }
    else if(tab.type == TabsService.MULTIPATH_TOOL){
      this.multipathToolController.openFooter(JSON.parse(tab.data));
    }
    else if(tab.type == TabsService.TERRAIN_GRID){
      this.terrainGridController.openWindow();
    }
    else if(tab.type == TabsService.CQA_RESULT){
      this.calculationService.showCQAResults(JSON.parse(tab.data));
    }
    else if(tab.type == TabsService.CREATE_CP_FROM_NAVAID){
      if(tab.data.includes('$')){
        let coords: string[] = tab.data.split("$");
        this.coordinatePointsController.setInitialCreateCPFromCoords(parseFloat(coords[0]),parseFloat(coords[1]));
      }
      else{
        this.coordinatePointsController.initializeSelectedCP(JSON.parse(tab.data))
      }
      this.coordinatePointsController.setCPFromNavaid();
    }
    else if(tab.type == TabsService.CREATE_CP_WITH_AZIMUTE_AND_DISTANCE){
      const coordsAndAzimuthDistance : string[] = tab.data.split('////')
      if(coordsAndAzimuthDistance[0].includes('$')){
        let coords: string[] = coordsAndAzimuthDistance[0].split("$");
        this.coordinatePointsController.setInitialCreateCPFromCoords(parseFloat(coords[0]),parseFloat(coords[1]));
      }
      else{
        this.coordinatePointsController.initializeSelectedCP(JSON.parse(coordsAndAzimuthDistance[0]));
      }
      const azimuthAndDistance :string[] = coordsAndAzimuthDistance[1].split('$');
      this.coordinatePointsController.setCPFromAzimuthAndDistance(parseFloat(azimuthAndDistance[0]),parseFloat(azimuthAndDistance[1]));
    }
    else if(tab.type ==TabsService.CREATE_NAVAID_FROM_MAP){
      this.navaidFromMapService.createNavaidFromMap();
    }
    else if(tab.type == TabsService.PROCEDURE_FROM_ASSOCIATED_NAVAIDS){
      let dataArray:string[] = tab.data.split("&&&&");
      let navaidFeatures:Feature[] = this.getFeaturesFromIDs(dataArray[0],FeatureType.Navaid,"$")
      let procedureFeatures:Feature[] = this.getFeaturesFromIDs(dataArray[1],FeatureType.Procedure,"$");
      this.procedureController.procedureNavaidAssociation(navaidFeatures,procedureFeatures);
    }
    else if(tab.type == TabsService.CREATE_AIRSPACE_BOUNDARIES_FROM_VERTICES){
      let cpFeatures : Feature[] = this.getFeaturesFromIDs(tab.data,FeatureType.CoordinatePoint,"$");
      this.airspaceBoundariesService.setInitialStateOfAirSpaceBoundaryFromSelectedVertices(cpFeatures);
    }
    else if(tab.type == TabsService.NAVAID_FILTER){
      this.navaidsFilterService.openWindow();
    }
    else if(tab.type == TabsService.PROCEDURE_FILTER){
      this.proceduresFilterService.openWindow();
    }
    else if(tab.type == TabsService.CP_FILTER){
      this.coordinatePointsFilterService.openWindow();
    }
    else if(tab.type == TabsService.AIR_SPACE_BOUNDARY_FILTER){
      this.airspaceBoundaryFilterService.openWindow();
    }
    else if (tab.type == TabsService.TRAJECTORY_FILTER){
      this.trajectoryFilterService.openWindow();
    }
    else if( tab.type == TabsService.PROCEDURE_ASSESSMENT){
      if(typeof tab.data == 'number'){
        let procedureFeature :Feature[] = this.pointsService.getAllProceduresFeaturesFromLayers().filter((feature) => feature.get('id') == tab.data);
        this.procedureAssessmentController.initializeProcedureFromFeature(procedureFeature);
      }
      else{
        const procedureHTML :ProcedureModel = JSON.parse(tab.data);
        let procedureFeature :Feature[] = this.pointsService.getAllProceduresFeaturesFromLayers().filter((feature) => feature.get('id') == procedureHTML.id);
        this.procedureAssessmentController.initializeProcedureFromFeature(procedureFeature,procedureHTML);
      }
      this.procedureAssessmentController.openFooter();

    } else if(tab.type == TabsService.NAVAID_CO_CHANNEL_CHECK){
      this.navaidsCoChannelCheckService.openWindow(JSON.parse(tab.data));
    }
    else if(tab.type == TabsService.FOM_CHECK){
      this.fomCheckservice.switchFooter();
    }
    else if(tab.type == TabsService.RANGE_RING){
      this.rangeRingService.openFooter();
    }
    else if(tab.type == TabsService.AZIMUTH_TOOL){
      this.azimuthToolService.openFooter()
    }
    else if(tab.type == TabsService.SAAM_Filter){
      this.saamTrafficService.openWindow();
    } else if (tab.type == TabsService.CROSS_SECTION) {
      this.crossSectionService.openWindow();
    }
    else if(tab.type == TabsService.PROJECT_DETAILS){
      this.projectDetailService.selectedProject = JSON.parse(tab.data);
      this.projectDetailService.active = true;
    } else if(tab.type == TabsService.SELF_TRAINING_TOOL){
      this.selfTrainingToolService.openWindow();
    }

    //#region GRIT Show tab
    switch (tab.type) {
      case TabsService.FEATURE_FILTER:
        this.featureFilterService.toggleFilterTab(true, tab.data as FeatureType)
        break;

      case TabsService.MANAGE_DEVICES:
        this.deviceService.toggleTab(true);
        break;

      case TabsService.MANAGE_RECEIVERS:
        this.receiverService.toggleTab(true);
        break;

      case TabsService.CREATE_DEVICE:
      case TabsService.EDIT_DEVICE:
        if(this.projectService.projectEditable()){
          this.interferenceTestDeviceService.showTab(JSON.parse(tab.data ?? null))
        }
        break;

      case TabsService.INTERFERENCE_TEST:
        this.interferenceTestService.toggleDetails(true, Number(tab.data))
        break;

/*      case TabsService.INTERFERENCE_TEST_FILTER:
        this.interferenceTestService.toggleFilter(true)
        break;*/

      case TabsService.CREATE_RADAR:
      case TabsService.EDIT_RADAR:
        if(this.projectService.projectEditable()){
          this.radarService.toggleDetails(true, JSON.parse(tab.data ?? null))
        }
        break;
    }
    //#endregion

    if(this.minimizeScreenMode){
      this.minimizeScreenMode = false;
      this.toolsService.navigationOnTop =true;
    }
    this.setCurrentTab(i);
    this.syncMapCenterAfterFooterLayout();
  }

  openNewCreateTab(type: string, data?:any){
    if (!this.projectService.projectEditable()){
      return;
    }
    let newTab: Tab = new Tab();
    newTab.type = type;
    let tabsOfType: Tab[] = this.tabs.filter((tab:Tab) => tab.type == type);
    let max = 0;
    if(data != null)
      newTab.data = JSON.stringify(data);
    for(let tab of tabsOfType){
      let number = JSON.parse(tab.header.split("#")[1]);
      if(number > max)
        max = number;
    }
    newTab.header = newTab.type + " #"+(max+1);
    this.openNewTab(newTab);
  }

  openNewCreateNavaidFromMap(navaid:NavaidModel){
    let newTab: Tab = new Tab();
    newTab.type = TabsService.CREATE_NAVAID_TYPE;
    newTab.data =JSON.stringify(this.navaidsControlService.getNavaidPayload(navaid));
    let index = this.currentIndex;
    this.openNewTab(newTab);
    this.tabs.splice(index,1);
    this.currentIndex--;
    this.updateTabs();

  }
  openNewToolsTab(type: string){
    let toolTab: Tab = new Tab();
    toolTab.type = type;
    let i = this.tabs.findIndex((tab) => tab.type == type)
    if(i == -1){
      this.openNewTab(toolTab);
      return;
    }
    this.showTab(i);
  }
  openNewRangeRing(){
    this.rangeRingService.openFooter();
    let i = this.tabs.findIndex((tab) => tab.type == TabsService.RANGE_RING);
    if(i == -1){
      let tab: Tab = new Tab();
      tab.type = TabsService.RANGE_RING;
      this.openNewTab(tab);
      return;
    }
    this.showTab(i)
  }
  openNewAzimuthTool(){
    this.azimuthToolService.openFooter();
    let i = this.tabs.findIndex((tab) => tab.type == TabsService.AZIMUTH_TOOL);
    if(i == -1){
      let tab: Tab = new Tab();
      tab.type = TabsService.AZIMUTH_TOOL;
      this.openNewTab(tab);
      return;
    }
    this.showTab(i)
  }
  openNewFomCheck(){
    if (!this.fomCheckservice.openFomCheck()){
      return;
    }
    let i = this.tabs.findIndex((tab) => tab.type == TabsService.FOM_CHECK);
    if(i == -1){
      let tab: Tab = new Tab();
      tab.type = TabsService.FOM_CHECK;
      this.openNewTab(tab);
      return;
    }
    this.showTab(i)
  }
  openNewMultipathTool(navaid: NavaidModel){
    let i = this.tabs.findIndex((tab) => tab.type == TabsService.MULTIPATH_TOOL)
    if(i == -1){
      let toolTab: Tab = new Tab();
      toolTab.type = TabsService.MULTIPATH_TOOL;
      toolTab.data = JSON.stringify(this.navaidsControlService.getNavaidPayload(navaid))
      this.openNewTab(toolTab);
      return;
    }
    this.tabs[i].data = JSON.stringify(this.navaidsControlService.getNavaidPayload(navaid))
    this.showTab(i);

  }
  async openNewEditNavaidTab(){
    if (!this.projectService.projectEditable()){
      return;
    }
    let newTab: Tab = new Tab();
    newTab.type = TabsService.EDIT_NAVAID_TYPE;

    let features : Feature[] = this.navaidsControlService.getEditNavaidFeatures();
    if(features == null){
      return;
    }
    if(features.length > 1){
      const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
        backdrop: 'static' // Prevent closing on backdrop click
      });
      bsModalRef.content.entity = "Navaids";
      bsModalRef.content.type = "Edit";
      bsModalRef.content.selectAllActive = false;
      bsModalRef.content.data = features;
      bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Navaids");

      bsModalRef.content.onClose.subscribe(async result => {
        if(result.length == 1){
          newTab.data = result[0].id;
          newTab.header = newTab.type + " - " +result[0].Id;
          await this.antennaPatternService.getAllAntennaModels();
          this.openNewTab(newTab);
        }
        else{
          this.modalService.showMesssageModal("Warning", "Select at least one Navaid to edit.");
        }
      });
    }
    else{
      newTab.data = features[0].get("id");
      newTab.header = newTab.type + " - " +features[0].get("navaidid");
      await this.antennaPatternService.getAllAntennaModels();
      this.openNewTab(newTab);
    }
  }
  openNewEditProcedureTab(isFromProcedureAssessment?: boolean){

    let newTab: Tab = new Tab();
    newTab.type = TabsService.EDIT_PROCEDURE;
    if (isFromProcedureAssessment){
      newTab.data = "fromProcedureAssessment";
      this.openNewTab(newTab);
      return;
    }

    let features: Feature[] = this.procedureController.getEditProcedureFeatures();
    if(features == null && !isFromProcedureAssessment){
      return;
    }
    if(features.length > 1){
      const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
        backdrop: 'static' // Prevent closing on backdrop click
      });
      bsModalRef.content.entity = "Procedures";
      bsModalRef.content.type = "Edit";
      bsModalRef.content.selectAllActive = false;
      bsModalRef.content.data = features;
      bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Procedures");
      bsModalRef.content.onClose.subscribe(result => {
        if(result.length == 1){
          newTab.data = JSON.stringify(this.pointsService.transformFeatureInProcedure(this.pointsService.getProcedureFeatureFromLayers(result[0].id)));
          newTab.header = newTab.type + " - " +result[0].Id;
          this.openNewTab(newTab);
        }
        else{
          this.modalService.showMesssageModal("Warning", "Select at least one Procedure to edit.");
        }
      });
    }
    else {
      newTab.data = JSON.stringify(this.pointsService.transformFeatureInProcedure(this.pointsService.getProcedureFeatureFromLayers(features[0].get('id'))));
      newTab.header = newTab.type + " - " +features[0].get('procedureid');
      this.openNewTab(newTab);
    }
  }

  openNewProcedureAssessment(){
    let tab: Tab = new Tab();
    tab.type = TabsService.PROCEDURE_ASSESSMENT;
    if (this.projectService.projectEditable()){
      this.procedureAssessmentController.selectedAirport = undefined;
      let features : Feature[] = this.pointsService.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Procedure);
      if(features.length > 1){
        const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
          backdrop: 'static' // Prevent closing on backdrop click
        });
        bsModalRef.content.entity = "Procedures";
        bsModalRef.content.type = "Edit";
        bsModalRef.content.selectAllActive = false;
        bsModalRef.content.data = features;
        bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Procedures");
        bsModalRef.content.onClose.subscribe(result => {
          if(result.length == 1){
            tab.data = JSON.stringify(this.pointsService.transformFeatureInProcedure(this.pointsService.getProcedureFeatureFromLayers(result[0].Id)));;
            tab.header = tab.type + " - " + result[0].Id;
            this.openNewTab(tab);
          }
        });
      }
      else if(features.length == 1){
        tab.data =JSON.stringify(this.pointsService.transformFeatureInProcedure(this.pointsService.getProcedureFeatureFromLayers(features[0].get('id'))));;
        tab.header = tab.type + " - " +features[0].get('procedureid');
        this.openNewTab(tab)
      }else{
        this.modalService.showMesssageModal("Warning", "Select at least 1 Procedure to edit.");
        return;
      }
    }
  }


  async openNewEditCP(){

    let newTab: Tab = new Tab();
    newTab.type = TabsService.EDIT_COORDINATE_POINTS;
    let coordinatePoints:CoordinatePointModel[] = null;
    try{
       coordinatePoints = this.pointsService.getSelectedCoordinatePoints();
    }catch(error){
      console.error(error);
    }
    if (coordinatePoints == null || coordinatePoints.length == 0) {
      this.modalService.showMesssageModal("Warning", "Select at least one Coordinate Point to edit.");
      return;
    }
    if(coordinatePoints.length > 1){
      const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
        backdrop: 'static' // Prevent closing on backdrop click
      });
      bsModalRef.content.entity = "Coordenate Points";
      bsModalRef.content.type = "Edit";
      bsModalRef.content.selectAllActive = false;
      bsModalRef.content.dataSource = DynamicTable.transformCoordinatePointsInDataSource(coordinatePoints);
      bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Coordenate Points");
      bsModalRef.content.onClose.subscribe(result => {
        if(result.length == 1){
          //this.menuService.toogleMenu();
          newTab.data = JSON.stringify(coordinatePoints.find(cp => cp.id == result[0].id));
          newTab.header = newTab.type + " - " +result[0].Id;
          this.openNewTab(newTab);

        }
        else{
          this.modalService.showMesssageModal("Warning", "Select at least one Coordinate Point to edit.");
        }
      });
    }else {
      newTab.data = JSON.stringify(coordinatePoints[0]);
      newTab.header = newTab.type + " - " +coordinatePoints[0].name;
      this.openNewTab(newTab);
    }
  }
  openNewEditAirspaceBoundary(){

    let newTab: Tab = new Tab();
    newTab.type = TabsService.EDIT_AIRSPACE_BOUNDARIES;
    let features : Feature[] = this.airspaceBoundariesService.getAirSpaceFeatures()
    if(features == null){
      return;
    }
    if(features.length > 1){
      const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
        backdrop: 'static' // Prevent closing on backdrop click
      });
      bsModalRef.content.entity = "Procedures";
      bsModalRef.content.type = "Edit";
      bsModalRef.content.selectAllActive = false;
      bsModalRef.content.data = features;
      bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Procedures");
      bsModalRef.content.onClose.subscribe(result => {
        if(result.length == 1){
          newTab.data = JSON.stringify(this.pointsService.transformFeatureInAirspaceBoundary(this.airspaceBoundariesService.findFeaturebyID(result[0].id)));
          newTab.header = newTab.type + " - " +result[0].Id;
          this.openNewTab(newTab);
        }
        else{
          this.modalService.showMesssageModal("Warning", "Select at least one Procedure to edit.");
        }
      });
    }
    else {
      newTab.data = JSON.stringify(this.pointsService.transformFeatureInAirspaceBoundary(this.airspaceBoundariesService.findFeaturebyID(features[0].get("id"))));
      newTab.header = newTab.type + " - " +features[0].get("uniqueid");
      this.openNewTab(newTab);
    }
  }

  openNewPerformanceReportTab(performanceAnalysis: PerformanceAnalysisDTO,data:any){
    let tab: Tab = new Tab();
    tab.type = TabsService.PERFORMANCE_REPORT;
    let report: PerformanceReportDTO = this.performanceReportService.getPerformanceReport(performanceAnalysis,data);
    tab.data = JSON.stringify(report);
    let headerNumber: number;
    let max = 0;
    this.tabs.filter((tab:Tab)=> tab.type == TabsService.PERFORMANCE_REPORT)
    .forEach((tab:Tab)=>{
      let currHeaderNumber = JSON.parse(tab.header.split('#')[1])
      if(currHeaderNumber > max){
        max = currHeaderNumber;
      }
    })
    headerNumber = max + 1;
    tab.header = tab.type + " #"+headerNumber;
    this.openNewTab(tab)
  }
  openNewPerformanceAnalysisTab(performanceAnalysis: PerformanceAnalysisDTO,data:any,id:number){

    let tab: Tab = new Tab();
    tab.type = TabsService.PERFORMANCE_ANALYSIS;

    let performanceAnalysisString : string = JSON.stringify(performanceAnalysis);
    tab.data = performanceAnalysisString +TabsService.SEPARATOR+ id  ;
    tab.header  = tab.type + " - " + performanceAnalysis.name;
    this.tabs.push(tab);
    let tabdto :TabDTO = this.createTabDTO(this.tabs);
    this.http.post(
        this.endpointService.apiURLTabsUpdate,
        tabdto,
        this.endpointService.httpOptions
      ).subscribe();
    this.footerActive = true;
    this.openTabs();
    this.setCurrentTab(this.tabs.length-1);
    this.calculationService.displayCalculation = DisplayCalculationInfo.getPerformanceAnalysisDisplay(performanceAnalysis);
    this.calculationService.showGeoJSONPerformanceAnalysis(data, true, true,true,performanceAnalysis.name,id, performanceAnalysis);
  }
  openNewVerticalProfileTab(performanceAnalysis: PerformanceAnalysisDTO,data:any){
    let tab: Tab = new Tab();
    tab.type = TabsService.VERTICAL_PROFILE;
    let result:string = JSON.stringify(data);
    let performanceAnalysisString : string = JSON.stringify(performanceAnalysis);

    tab.data = result + TabsService.SEPARATOR + performanceAnalysisString;
    this.openNewTab(tab);
  }
  openNewCoveraveQuantitativeAssessmentTab(data: any){
    let tab: Tab = new Tab();
    tab.type = TabsService.CQA_RESULT
    tab.data = JSON.stringify(data)
    this.openNewTab(tab)
  }
  getIDsFromFeatures(features: Feature[],separator:string){
    if(features.length == 0){
      return "";
    }
    let data = features[0].get('id');
    for(let i = 1; i < features.length; i++){
      data += separator+features[i].get('id');
    }
    return data;
  }
  getFeaturesFromIDs(ids:string, type:number,separator:string):Feature[]{
    if(ids == ""){
      return [];
    }
    let features:Feature[];
    if(type == FeatureType.Navaid){
      features = this.pointsService.getAllNavaidsFeaturesFromLayers();
    }
    else if(type == FeatureType.Procedure){
      features = this.pointsService.getAllProceduresFeaturesFromLayers();
    }
    else if(type == FeatureType.CoordinatePoint){
      features = this.pointsService.getAllCoordinatePointsFeaturesFromLayers()
    }
    let featuresToReturn :Feature[]= [];
    let idsArray = ids.split(separator);
    for(let id of idsArray){
      let feature = features.find((features)=> features.get('id') == parseInt(id));
      featuresToReturn.push(feature);
    }
    return featuresToReturn;
  }
  openNewOpenNewCreateProcedureFromSelectedZoneTab(){
    if (!this.projectService.projectEditable()){
      return;
    }
    let features : Feature[] = this.pointsService.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.CoordinatePoint);
    if(features.length <= 1){
      this.modalService.showMesssageModal("Create Procedure","Please select more than one Coordinate Point.");
      return;
    }
    let tab: Tab = new Tab();
    tab.type = TabsService.CREATE_PROCEDURE_FROM_SELECTED_ZONE
    tab.data = this.getIDsFromFeatures(features,"$");
    this.openNewTab(tab);
  }
  openNewProcedureNavaidsAssociation(){
    let tab: Tab = new Tab();
    tab.type = TabsService.PROCEDURE_FROM_ASSOCIATED_NAVAIDS;
    let navaidFeatures :Feature[] = this.pointsService.getSelectedFeaturesOfType(FeatureType.Navaid);
    let procedureFeatures : Feature[] = this.pointsService.getSelectedFeaturesOfType(FeatureType.Procedure);

    let navaidIds:string = this.getIDsFromFeatures(navaidFeatures,"$");
    let procedureIds: string = this.getIDsFromFeatures(procedureFeatures,"$");

    tab.data = navaidIds + "&&&&" + procedureIds;
    this.openNewTab(tab);
  }



  openCreateCPFromCoords(azimuthAndDistance:boolean){
    if (!this.projectService.projectEditable()){
      return;
    }
    let tab: Tab = new Tab();
    tab.type = azimuthAndDistance? TabsService.CREATE_CP_WITH_AZIMUTE_AND_DISTANCE : TabsService.CREATE_CP_FROM_NAVAID;
    let features : Feature[] = this.pointsService.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Navaid);
    let lat:number;
    let lon:number;
    if(features.length > 1){
      const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
        backdrop: 'static' // Prevent closing on backdrop click
      });
      bsModalRef.content.entity = "Navaids";
      bsModalRef.content.type = "Create";
      bsModalRef.content.selectAllActive = false;
      bsModalRef.content.data = features;
      bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Navaids");
      bsModalRef.content.onClose.subscribe(result => {
        if(result.length == 1){
          lat = result[0].latitude;
          lon = result[0].longitude;
        }
        else{
          this.modalService.showMesssageModal("Warning", "Select at least one Navaid to create a Coordinate Point from it.");
          return;
        }
      });
    }else if (features.length == 1){
      lat = features[0].get("latitude");
      lon = features[0].get("longitude");
    }else{
      this.modalService.showMesssageModal("Warning", "Select at least one Navaid to create a Coordinate Point from it.");
      return;
    }
    tab.data = lat+"$"+lon;
    if(azimuthAndDistance){
      tab.data += '////' + 0.0 + '$' + 0.0;
    }
    this.openNewTab(tab);
  }

  openNewAirSpaceBoundariesFromSelectedVerticesTab(){
    if (!this.projectService.projectEditable()){
      return;
    }
    let tab : Tab = new Tab();
    tab.type = TabsService.CREATE_AIRSPACE_BOUNDARIES_FROM_VERTICES;
    let features : Feature[] = this.pointsService.getSelectedFeaturesOfType(FeatureType.CoordinatePoint);
    let verticesSelected:number = 0;
    for (const feature of features){
      if (feature.get("type") == getCoordinatePointTypesKeyByValue(CoordinatePointTypes.AIRSPACE_BOUNDARY_VERTEX)){
        verticesSelected++
      }
    }
    if(verticesSelected < 3){
      this.modalService.showMesssageModal("Create Air Space Boundary","Please select more than two Air Space Boundary Vertices.");
      return;
    }
    let ids:string = this.getIDsFromFeatures(features,"$");
    tab.data = ids;
    this.openNewTab(tab);

  }
  openNewProjectDetailsTab(){
    let i : number = this.tabs.findIndex((tab) => tab.type == TabsService.PROJECT_DETAILS)
    if(i == -1){
      let tab : Tab = new Tab();
      tab.type = TabsService.PROJECT_DETAILS;
      tab.data = JSON.stringify(this.projectService.activeProject);
      this.openNewTab(tab);
      return;
    }
    this.showTab(i,false,false,true);
  }
  openNewNavaidsCoChannelCheck(){
    let tab : Tab;
    const tabIndex = this.tabs.findIndex(tab => tab.type == TabsService.NAVAID_CO_CHANNEL_CHECK);
    let openNewTab: boolean = false;
    if (tabIndex == -1){
      tab = new Tab();
      tab.type = TabsService.NAVAID_CO_CHANNEL_CHECK;
      openNewTab = true;
    } else {
      tab = this.tabs[tabIndex];
    }
    let features : Feature[] = this.pointsService.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Navaid);
    const selectedNavaids: NavaidModel[] = [];
    for (const navaid of features){
      selectedNavaids.push(this.pointsService.transformFeatureInNavaid(navaid));
    }
    if (selectedNavaids.length == 0){
      this.modalService.showMesssageModal("Warning","Select at least 1 NavAid.");
      return;
    }
    let ids:string = this.getIDsFromFeatures(features,"$");
    const navaidsPayload: NavaidModel[] = [];
    for (const nav of selectedNavaids){
      navaidsPayload.push(this.navaidsControlService.getNavaidPayload(nav));
    }

    tab.data = JSON.stringify(navaidsPayload);
    if (openNewTab){
      this.openNewTab(tab);
    } else {
      this.showTab(tabIndex);
    }
  }

  openNewAnalysisTool(calcId: number, calcType: string, calcName: string, layerName? : string){
    const tab = new Tab();
    tab.type = TabsService.ANALYSIS_TOOL;
    tab.data = calcId.toString();
    tab.header = this.getAnalysisToolTabHeader(calcType, calcName,layerName);

    if (calcType == "PERFORMANCE"){
      tab.data += TabsService.SEPARATOR + layerName;
    }

    this.openNewTab(tab);
  }

  updateAnalysisToolTabsHeaders(calcId: number, calcType: string, calcName: string){
    let activeTabs: Tab[] = this.getActiveAnalysisToolTabs(calcId);
    if (activeTabs && activeTabs.length > 0){
      for (const tab of activeTabs){
        tab.header = this.getAnalysisToolTabHeader(calcType, calcName);
      }
    }
    this.updateTabs();
  }

  private getAnalysisToolTabHeader(calcType: string, calcName: string,layerName?:string): string{
    let header: string;
    switch (calcType){
      case "Impact Assessment":
        header = "Impact Assessment";
        break;
      case "DocAndSectorizationDisplay":
        header = "DOC and Sectorization";
        calcName = null;
        break;
      case "PERFORMANCE":
        if(layerName == this.analysisToolService.getPairsAnalysisFlag()){
          header = layerName;
        }
        else{
          header = "Performance";
        }
        break;
      case "Overlap":
        header = "Overlap Plot"
        break;
      default:
        header = "Coverage";
    }
    if(calcType != 'PERFORMANCE' || layerName != this.analysisToolService.getPairsAnalysisFlag()){
      header += " Results";
      calcName != null && calcName != "" ? header += " : " + calcName: false;
    }

    return header;

  }

  forceCloseAnalysisTool(calcID:number){
    let activeTabs: Tab[] = this.getActiveAnalysisToolTabs(calcID);
    if (activeTabs && activeTabs.length > 0){
      for (const tab of activeTabs){
        const index = this.tabs.indexOf(tab);
        this.closeTab(index,true);
      }
    }
  }
  private getActiveAnalysisToolTabs(calcID:number){
    return this.tabs.filter((tab) => tab.type == TabsService.ANALYSIS_TOOL &&
    tab.data.split(TabsService.SEPARATOR)[0] == calcID.toString());
  }

  openNewCalculationConfiguration(calcId: number, calcType: string, calcName: string){
    const tab = new Tab();
    tab.type = TabsService.CALCULATION_CONFIGURATION;
    tab.data = calcId.toString() + TabsService.SEPARATOR + calcType;
    tab.header = TabsService.CALCULATION_CONFIGURATION + ": " + calcName;

    this.openNewTab(tab);
  }

  //#region GRIT Methods
  private openUniqueTab(tab: Tab, replace: boolean = false){
    let i = this.tabs.findIndex((t:Tab) => t.header == tab.header && t.data == tab.data);

    if(i != -1) {
      if (replace){
        this.tabs[i] = tab;
      }

      this.showTab(i, false, false, true);
    }
    else{
      this.openNewTab(tab);
    }
  }

  public gritOpenUniqueTab(type: string, data: any = null){
    let newTab: Tab = new Tab();
    newTab.type = newTab.header = type;
    if(!data) newTab.data = JSON.stringify(data);

    this.openUniqueTab(newTab);
  }


  unselectTab(type: string = null){
    if (type == null || this.currentTab?.type == type) {
      this.hideTab(this.currentTab);
      this.currentTab = null;
      this.currentIndex = -1;
      this.minimizeWindow();
    }
  }

  async openEditDeviceTab(){
    let features = await this.pointsService.getGritSelected<InterferenceTestDeviceModel>(FeatureType.Device, GritDynamicTableMode.SELECT_ONE);
    if(features == null) return;

    let device = features[0].entity;
    let newTab: Tab = new Tab();
    newTab.type = TabsService.EDIT_DEVICE;
    newTab.data = JSON.stringify(device.toDTO());
    newTab.header = newTab.type + " - " + device.name

    this.openUniqueTab(newTab);
  }

  async openEditRadarTab(){
    let features = await this.pointsService.getGritSelected<RadarModel>(FeatureType.Radar, GritDynamicTableMode.SELECT_ONE);
    if(features == null) return;

    let radar = features[0].entity;
    let newTab: Tab = new Tab();
    newTab.type = TabsService.EDIT_RADAR;
    newTab.data = JSON.stringify(radar);
    newTab.header = newTab.type + " - " + radar.name

    this.openUniqueTab(newTab);
  }

  openFilterTab(featureType: FeatureType){
    let newTab: Tab = new Tab();
    newTab.type = TabsService.FEATURE_FILTER;
    newTab.header = `${featureType} ${TabsService.FEATURE_FILTER}`;
    newTab.data = featureType.toString();

    this.openUniqueTab(newTab);
  }

  openInterferenceTestTab(interferenceTest: InterferenceTestModel = null){
    if (interferenceTest == null) interferenceTest = this.interferenceTestService.projectInterferenceTest;

    let additionalHeader = interferenceTest.id == this.interferenceTestService.projectInterferenceTest?.id ? '' : ` - ${interferenceTest.name}`

    let newTab: Tab = new Tab();
    newTab.type = TabsService.INTERFERENCE_TEST;
    newTab.header = TabsService.INTERFERENCE_TEST + additionalHeader;
    newTab.data = String(interferenceTest.id);

    this.openUniqueTab(newTab);
  }

  removeInterferenceTestTabById(id: number){
    let i = this.tabs.findIndex(tab => tab.data === String(id))
    if (i != -1) this.closeTab(i);
  }
  //#endregion
}

